import once from '../../utils/events/once';


const listen = () => {
  once(document, 'keydown', () => {
    document.body.classList.add('tn--key-pressed');
  }, { capture: true });
};


export default {
  listen,
};
